/* 3.3.2 — the Vue flyout cart (mag.__packed__ bundle, no source available)
   renders its quantity input without a label. Patch the accessible name
   from outside the bundle rather than editing minified vendor code.
   The observer re-applies it whenever Vue re-renders the flyout. */
(function () {
  function labelQtyInputs() {
    document
      .querySelectorAll('.mgp-flyout input[name="quantity"]:not([aria-label])')
      .forEach(function (el) {
        el.setAttribute('aria-label', 'Quantity');
      });
  }
  labelQtyInputs();
  new MutationObserver(labelQtyInputs).observe(document.body, {
    childList: true,
    subtree: true
  });
})();